// @ts-nocheck
import { getLedgers, GetLedgersApiParameter } from "@store/Framework/Services/LedgerService";
import { LedgerCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner, HasOnComplete } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetLedgersApiParameter & HasOnComplete, LedgerCollectionModel>;

export const DispatchBeginLoadLedgers: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Ledgers/BeginLoadLedgers",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getLedgers(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({ type: "Store/Data/Ledgers/FailedToLoadLedgers" });
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadLedgers: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Ledgers/CompleteLoadLedgers",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [DispatchBeginLoadLedgers, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadLedgers];

const loadLedgers = createHandlerChainRunner(chain, "LoadWishLists");
export default loadLedgers;
